import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBreadcrumbArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 11,
	viewBox: "0 0 8 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.1697 0.500051C0.983447 0.687414 0.878906 0.940866 0.878906 1.20505C0.878906 1.46924 0.983447 1.72269 1.1697 1.91005L4.7097 5.50005L1.1697 9.04005C0.983448 9.22741 0.878906 9.48087 0.878906 9.74505C0.878906 10.0092 0.983448 10.2627 1.1697 10.4501C1.26266 10.5438 1.37326 10.6182 1.49512 10.6689C1.61698 10.7197 1.74769 10.7458 1.8797 10.7458C2.01171 10.7458 2.14242 10.7197 2.26428 10.6689C2.38613 10.6182 2.49674 10.5438 2.5897 10.4501L6.8297 6.21005C6.92343 6.11709 6.99782 6.00649 7.04859 5.88463C7.09936 5.76277 7.1255 5.63206 7.1255 5.50005C7.1255 5.36804 7.09936 5.23733 7.04859 5.11547C6.99782 4.99362 6.92343 4.88301 6.8297 4.79005L2.5897 0.500051C2.49674 0.406323 2.38613 0.331929 2.26428 0.28116C2.14242 0.230391 2.01171 0.204252 1.8797 0.204252C1.74769 0.204252 1.61698 0.230391 1.49512 0.28116C1.37326 0.331929 1.26266 0.406323 1.1697 0.500051Z",
		fill: "#868686"
	})
});
export default SvgBreadcrumbArrow;
